import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';

export default class DownloadButton extends Component {

    constructor($element) {
        super($element);
        this.$footer = $('.section-footer');
    }

    prepare() {

        this.$element.on('click', event => {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $(event.currentTarget.hash).offset().top
            }, 250);
        });

        enquire.register(queries.largeUp, {
            match: ::this.attach,
            unmatch: ::this.detach
        });
    }

    attach() {
        $(window).on('scroll orientationchange load', event => {
            if (this.check(this.$element.offset().top)) {
                if (!this.$element.hasClass('is-hidden')) {
                    this.$element.addClass('is-hidden')
                }
            } else {
                this.$element.removeClass('is-hidden')
            }
        });
    }

    detach() {
        this.$element.removeClass('is-hidden')
    }

    check(offset) {
        const footerTopBottom = [this.$footer.offset().top, this.$footer.offset().top + this.$footer.height()];

        if (offset >= footerTopBottom[0]) {
            return true
        } else {
            return false
        }
    }

}


// WEBPACK FOOTER //
// ./components/DownloadButton.js